import { render, staticRenderFns } from "./SkeletonRecoMobilesCard.vue?vue&type=template&id=60290f86&"
import script from "./SkeletonRecoMobilesCard.vue?vue&type=script&lang=js&"
export * from "./SkeletonRecoMobilesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60290f86')) {
      api.createRecord('60290f86', component.options)
    } else {
      api.reload('60290f86', component.options)
    }
    module.hot.accept("./SkeletonRecoMobilesCard.vue?vue&type=template&id=60290f86&", function () {
      api.rerender('60290f86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/selector/fragment/SkeletonRecoMobilesCard.vue"
export default component.exports